<!-- Footer Start -->
<footer
  class="footer mt-auto xl:ps-[15rem]  font-normal font-mont bg-white dark:!bg-bodybg text-defaultsize leading-normal text-[0.813] !border-t !border-defaultborder dark:!border-defaultborder/10 py-4 text-center">
  <div class="container">
    <span class="text-textmuted dark:text-textmuted/50"> Copyright © 2025 <span id="year"></span> <a
        href="https://finapay.net" class="text-defaulttextcolor font-semibold dark:text-defaulttextcolor">FinaPay</a>.
      Tous droits réservés.
    </span>
  </div>
</footer>
<!-- Footer End -->